/**
 * List all components, that should be resolved automatically with gatsby source graphql.
 * Format: {componentName}.{key}
 * With key beeing the field, that is a linked story ressource via options, or multioptions in
 * in the defined component.
 */
const autoResolveField = [
  'rcm-editorial-big-feature.article',
  'editorial-item.page',
  'article.category',
  'rcm-disclaimer.disclaimers',
  'rcm-topics.categories',
  'rcm-layout-funds.quickfilters',
  'ffquestionnaire',
];

export const getGatsbySourceGraphqlConfig = () => {
  return {
    options: {
      accessToken: process.env.GATSBY_STORYBLOK_SPACE_API_KEY,
      typeName: 'Storyblok',
      fieldName: 'storyblok',
      url: 'https://gapi.storyblok.com/v1/api',
      headers: {
        Token: `${process.env.GATSBY_STORYBLOK_SPACE_API_KEY}`,
        Version: `${process.env.GATSBY_ENV === 'live' ? 'published' : 'draft'}`,
      },
      resolveRelations: autoResolveField.join(','),
      resolveLinks: 'url',
    },
  };
};
